var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal show",class:_vm.classes},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-dialog-scrollable",class:_vm.modalSize},[_c(_vm.selectedModal,_vm._b({tag:"component"},'component',_vm.args,false))],1)]),_c('div',{staticClass:"modal-backdrop show"})])
}
var staticRenderFns = []

export { render, staticRenderFns }